// Types for PointsCard
import { CardType } from '../../modules/constants/constants';

export enum VariationType {
  Default = 'default',
  BankLanding = 'banklanding',
}

export enum ColumnLayout {
  Two = '2',
  Three = '3',
}

export type PointsCardProps = {
  number: string;
  content: string;
  isOnSpend: boolean;
  cardType: CardType | string;
  column?: ColumnLayout | string;
  customClass?: string;
  styleClass?: string;
  bonusLabel?: string;
  pointsForCarddetails?: boolean;
  variationType?: VariationType | string;
  isBonusPointsLabelVisible?: boolean;
  layoutType?: string;
};
